import { Box, Button, Text, VStack } from 'native-base';
import React from 'react';

import CPActionSheet from 'app/components/CPActionSheet/CPActionSheet';
import { useI18n } from 'app/providers/I18nProvider';
import { tID } from 'app/services/TestHelper';

export type PurchasesManualAddSheetProps = {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
};

export default function PurchasesManualAddSheet({
  isOpen,
  onClose,
  onContinue,
}: PurchasesManualAddSheetProps) {
  const { t } = useI18n();

  return (
    <CPActionSheet
      isOpen={isOpen}
      testID={tID('PurchasesManualAddSheet')}
      title={t('app_auth_add_manual_tickets_confirm_title') as string}
      onClose={onClose}
    >
      <Box width="100%">
        <VStack space="8">
          <Text color="black">{t('app_auth_add_manual_tickets_confirm_body')}</Text>

          <Button testID={tID('PurchasesManualAddContinue')} w="full" onPress={onContinue}>
            {t('gen_continue')}
          </Button>
        </VStack>
      </Box>
    </CPActionSheet>
  );
}
